export enum messengerEvents {
  sendNotice = 'sendNotice',
  getChats = 'getChats',
  getChat = 'getChat',
}
